import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../../components/BreadCrumbs';
import Pagination from '../../../components/tables/pagination/Pagination';
import CustomLoading from '../../../components/customLoading/CustomLoading';
import Table from '../../../components/tables/Table';
import loaderImage from "../../../assets/icons/part-logo.png";
import StyledHeadingText from '../../../components/Fonts/StyledHeadingText';
import Card from '../../../components/cards/Card';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { BiCheckCircle, BiHistory, BiPencil, BiSolidCheckCircle } from 'react-icons/bi';
import { GoPackage } from 'react-icons/go';
import Button from '../../../components/buttons/Button';
import { LuFileScan } from 'react-icons/lu';
import SearchBar from '../../../components/searchBar/SearchBar';
import { getNewHudPatients, updateNewHudPatientDoctorView } from '../../../services/new_clinic/new_hud_patients';
import { getBranchWiseDoctorStats } from '../../../services/doctor/doctor_view_dashboard';
import { getUserName } from '../../../utils/localStoarege';


function NewHudPatients() {
    const [cardData, setCardData] = useState([]);

    const [tableData, setTableData] = useState({});
    const headers = [
        { label: "Edit", key: "edit" },
        { label: "Files", key: "files" },
        { label: "History", key: "history" },
        { label: "Package", key: "package" },
        { label: "Show", key: "dr" },
        { label: "S/N", key: "sn" },
        { label: "Name", key: "full_name" },
        { label: "Gender", key: "gender" },
        { label: "Address", key: "address" },
        { label: "Phone", key: "phone_number" },
        { label: "Addon", key: "date" },
        { label: "Skin Type", key: "skin_type" },
        { label: "System Code", key: "system_code" },
    ];

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);

    const pageSize = 10;

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getNewHudPatients(query);
            if (res.status === 200) {
                setTableData(res.data);
            } else {
                toast.error("Unable to fetch Patients");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error fetching Patients:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (query) => {
        fetchData("&search=" + query);
    };

    const handleDrView = async (item) => {
        setLoading(true);
        try {
            let res = await updateNewHudPatientDoctorView(null, item.patient_id);
            if (res.status === 200) {
                fetchData("");
                toast.success(`${item.name} activated on doctor's view`);
            } else {
                toast.error("Unable to change deoctor view");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error updating doctor view:", error);
        } finally {
            setLoading(false);
        }
    };


    const fetchCardData = async () => {
        try {
            let res = await getBranchWiseDoctorStats({ branch: getUserName() });
            if (res.status === 200) {
                setCardData(res.data.stats);
            } else {
                toast.error("Unable to fetch Patient Graph");
            }
        } catch (error) {
            console.error("Unable to fetch Patient Graph", error);
        }
    };

    useEffect(() => {
        fetchData("");
        fetchCardData();
    }, []);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    return (<>
        <div className="flex flex-row justify-between items-center">
            <div className="flex flex-row gap-1">
                <Breadcrumbs items={[
                    { name: 'Home', link: '/package-invoice' },
                    { name: 'Patients' },
                ]} />
                <StyledHeadingText text={"| Patients"} size={"text-xs"} />
            </div>
            <Link to="/new-hud-patients/add">
                <Button
                    type="button"
                    className="bg-primary text-xs text-white px-4 py-2 rounded"
                    disabled={loading}
                >
                    Add Patient
                </Button>
            </Link>
        </div>
        <div className="py-1">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-4 gap-4 mt-2 mb-4">
                {cardData.map((card, index) => (
                    <Link to={card.clickable ? "/new-hud-filtered-patients" : null} state={card} className={`${card.clickable ? "" : "cursor-default"}`}>
                        <div className={`relative p-4 bg-white shadow-md rounded-lg overflow-hidden ${card.clickable ? "hover:shadow-md" : ""}`}>
                            <h3 className="text-sm font-semibold text-[#6B7280]">{card.title}</h3>
                            <hr />
                            <p className="text-lg font-bold">{card.value}</p>
                            {card.icon && (
                                <div className="absolute bottom-2 right-2 opacity-55 text-4xl">
                                    <img src={card.icon} alt={card.icon} className='object-contain h-8' />
                                </div>)}
                        </div>
                    </Link>
                ))}
            </div>
        </div>
        <div className="bg-white p-4 w-full rounded border-primary border-t-2">
            <div className="flex flex-row justify-end">
                <div className="md:w-[30%] lg:w-[20%] self-end">
                    <SearchBar placeholder="Search Patients..." onSearch={handleSearch} />
                </div>
            </div>
            {
                loading ?
                    <div className="flex w-full flex-row justify-center my-2">
                        <CustomLoading imageSrc={loaderImage} size={100} />
                    </div>
                    :
                    <div className="mt-2">
                        <Table
                            headers={headers}
                            rows={tableData?.results?.map((item, index) => (
                                {
                                    edit: <Link to={`/new-hud-patients/${item.patient_id}/`} state={item}><BiPencil size={17} color='blue' /></Link>,
                                    files: <Link to={`/new-hud-patients/files/`} state={item}><LuFileScan size={17} color='purple' /></Link>,
                                    history: <Link to={`/new-hud-patients/history/`} state={item}><BiHistory size={17} color='red' /></Link>,
                                    package: <Link to={`/new-hud-patients/packages/`} state={item}><GoPackage size={17} color='green' /></Link>,
                                    dr: <Button onClick={() => handleDrView(item)}>{item.is_activated ? <BiSolidCheckCircle size={17} color='orange' /> : <BiCheckCircle size={17} color='black' />}</Button>,
                                    full_name: <b className='text-black'>{item.name}</b>,
                                    address: <p>{item.address}</p>,
                                    gender: <p className='w-full text-center'>{item.gender}</p>,
                                    phone_number: <p>{item.phone_number}</p>,
                                    sn: <p>{item.patient_id ?? "-"}</p>,
                                    skin_type: <p>{item.skin_type}</p>,
                                    system_code: <p>{item.system_code}</p>,
                                    date: <p>{item.date_created}</p>,
                                }))}
                        />
                    </div>}
            {
                tableData.count !== 0 ?
                    <div className="xl:pl-5 pl-0">
                        <Pagination
                            currentPage={currentPage}
                            totalPages={Math.ceil(tableData?.count / pageSize)}
                            pageSize={pageSize}
                            totalEntries={tableData?.count}
                            onPageChange={handlePageChange}
                            data={tableData}
                            setTableData={setTableData}
                        />
                    </div> : <></>
            }
        </div>
    </>);
}

export default NewHudPatients;